import React from "react";
import { NavLink, useNavigate } from "react-router-dom";
import {
    LayoutDashboard, Compass, Users, Store, Library, Wallet,
    Coins, ShieldAlert, Truck, Mail, Settings, Palette, FileText, LogOut, Layers,
} from "lucide-react";
import BrandLogo from "@/components/brand/BrandLogo";
import { useAuth } from "@/contexts/AuthContext";

const NAV = [
    { to: "/admin", end: true, slug: "dashboard", label: "Dashboard", icon: LayoutDashboard },
    { to: "/admin/missions", slug: "missions", label: "Missions", icon: Compass },
    { to: "/admin/utilisateurs", slug: "users", label: "Utilisateurs", icon: Users },
    { to: "/admin/vendeurs", slug: "vendors", label: "Vendeurs", icon: Store },
    { to: "/admin/catalogue", slug: "catalog", label: "Catalogue", icon: Library },
    { to: "/admin/categories", slug: "categories", label: "Catégories", icon: Layers },
    { to: "/admin/pricing", slug: "pricing", label: "Pricing", icon: Coins },
    { to: "/admin/paiements", slug: "payments", label: "Paiements", icon: Wallet },
    { to: "/admin/litiges", slug: "disputes", label: "Litiges", icon: ShieldAlert },
    { to: "/admin/transport", slug: "shipping", label: "Transport", icon: Truck },
    { to: "/admin/emails", slug: "emails", label: "Emails", icon: Mail },
    { to: "/admin/brand", slug: "brand", label: "Brand", icon: Palette },
    { to: "/admin/parametres", slug: "parametres", label: "Paramètres", icon: Settings },
    { to: "/admin/audit", slug: "audit", label: "Audit logs", icon: FileText },
];

function linkClass({ isActive }) {
    return `group flex items-center gap-3 rounded-lg px-3 py-2 text-sm font-medium transition-colors ${
        isActive
            ? "bg-md-primary text-md-primary-fg"
            : "text-md-text-2 hover:bg-md-surface-2 hover:text-md-text"
    }`;
}

export function AdminSidebar() {
    const { admin, logoutAdmin } = useAuth();
    const navigate = useNavigate();
    return (
        <aside
            data-testid="admin-sidebar"
            className="hidden lg:flex w-64 shrink-0 flex-col border-r border-md-border bg-md-surface"
        >
            <div className="flex h-16 items-center border-b border-md-border px-5">
                <BrandLogo variant="horizontal" size="sm" to="/admin" />
            </div>
            <nav className="flex-1 space-y-1 overflow-y-auto p-3 md-scroll">
                {NAV.map((item) => (
                    <NavLink
                        key={item.to}
                        to={item.to}
                        end={item.end}
                        className={linkClass}
                        data-testid={`admin-nav-${item.slug}`}
                    >
                        <item.icon className="h-4 w-4" />
                        <span>{item.label}</span>
                    </NavLink>
                ))}
            </nav>
            <div className="border-t border-md-border p-3">
                <div className="mb-3 rounded-lg bg-md-surface-2 px-3 py-2">
                    <p className="text-[10px] font-bold uppercase tracking-wider text-md-text-2">Connecté</p>
                    <p className="truncate text-xs font-medium text-md-text">
                        {admin?.email || "admin"}
                    </p>
                </div>
                <button
                    onClick={async () => { await logoutAdmin(); navigate("/admin/login"); }}
                    data-testid="admin-logout"
                    className="inline-flex w-full items-center justify-center gap-2 rounded-lg border border-md-border bg-transparent px-3 py-2 text-xs font-semibold text-md-text hover:bg-md-surface-2"
                >
                    <LogOut className="h-3.5 w-3.5" /> Déconnexion
                </button>
            </div>
        </aside>
    );
}

export default AdminSidebar;
